<template>
  <div class="showcase-home-hero-register showcase-home-hero-login">
    <div class="header">
      <div class="title">
        {{ currentStep.title }}
      </div>
      <div class="status">{{ statusText }}</div>
    </div>
    <div class="content">
      <TextField
        class="white outline transparent blur big"
        v-model="name"
        placeholder="用户"
      />
      <TextField
        class="white outline transparent blur big"
        type="password"
        v-model="password"
        placeholder="密码"
      />
      <div class="action">
        <button
          class="button outline white transparent blur big block"
          @click="onClickActionButton"
        >
          {{ actionButtonText }}
        </button>
      </div>
    </div>
    <div class="footer">
      <div class="action">
        <button class="button basic" @click="onClickBackButton">
          {{ actionText }}
        </button>
        <button class="button basic" @click="onClickWxLoginButton">
          {{ wxLoginActionText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import TextField from '@/app/components/text-field';

export default defineComponent({
  name: 'ShowcaseHomeHeroLogin',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {
      defaultStatusText: '长风破浪，直挂云帆。',
      statusText: '长风破浪，直挂云帆。',
      name: '',
      password: '',
    };
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      currentStepName: 'invite/currentStepName',
      currentStep: 'invite/currentStep',
    }),

    actionButtonText() {
      return '立即登录';
    },

    actionText() {
      return '← 回到前台';
    },

    wxLoginActionText() {
      return '微信登录 →';
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setCurrentStepName: 'invite/setCurrentStepName',
    }),

    ...mapActions({
      login: 'auth/login/login',
    }),

    async onClickActionButton() {
      if (!this.name) {
        return (this.statusText = '请输入用户名。');
      }

      if (!this.password) {
        return (this.statusText = '请输入用户密码。');
      }

      try {
        await this.login({
          name: this.name,
          password: this.password,
          device: { type: 'web' },
        });

        this.$router.push('/');
      } catch (error) {
        if (error.data && Array.isArray(error.data.message)) {
          this.statusText = error.data.message[0];
        }

        if (
          error.data &&
          !Array.isArray(error.data.message) &&
          error.data.message
        ) {
          this.statusText = error.data.message;
        }
      }
    },

    onClickBackButton() {
      this.setCurrentStepName('initial');
    },

    onClickWxLoginButton() {
      this.setCurrentStepName('weixinLogin');
    },
  },

  /**
   * 使用组件
   */
  components: {
    TextField,
  },
});
</script>
<style scoped>
@import './styles/showcase-home-hero-login.css';
</style>
